import React from 'react'

import Form from '../../../gd-form/form/form-modal-new/form-modal-new'
import FormManager from "../../../gd-form/common/form-manager"
import FormSelect from "../../../gd-form/form-element/select-new/select-new"
import FormError from "../../../gd-form/common/form-error/form-error";

const debug: boolean = false
// const debug: string = "ModalEditDocumentType"

interface EditDocumentTypeProps {
    document: any,
    onSubmit: (result: any)=>any
}

export default class ModalDocument_EditType extends React.Component<EditDocumentTypeProps, any> {

    private form: any

    constructor(props: EditDocumentTypeProps) {
        super(props)

        this.state = {
            documentTypeId: null
        }

        const initFormData: any = {
            documentType: props.document.noteTypeId
        }

        const formStructure = {
            fields  : {
                documentType: {
                    type        : 'select',
                    isRequired  : true,
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData)
    }

    onSubmit = (result: any):void => {
        this.props.onSubmit(result)
    }

    render() {

        const documentTypesOptions: any[] = _.map(gd.session.noteTypes.filterByCompany(gd.companyId).models, m=>({
            value   : m.id,
            icon    : gd.const.note.icon[m.icon],
            label   : m.name,
        }))

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="tbl">
                    <div className="row">
                        <div className="label">Document type</div>
                        <div className="element">
                            <FormSelect size        = "big"
                                        renderValue = "icon-text"
                                        options     = {documentTypesOptions}
                                        form        = {this.form}
                                        name        = "documentType"/>
                            <FormError form={this.form} name="documentType" />
                        </div>
                    </div>
                </div>
            </Form>
        )
    }
}